var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_487_1010)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 18C25.5523 18 26 18.4477 26 19V20H30V19C30 18.4477 30.4477 18 31 18C31.5523 18 32 18.4477 32 19V20H33C34.6569 20 36 21.3431 36 23V35C36 36.6569 34.6569 38 33 38H23C21.3431 38 20 36.6569 20 35V23C20 21.3431 21.3431 20 23 20H24V19C24 18.4477 24.4477 18 25 18ZM30 22V23C30 23.5523 30.4477 24 31 24C31.5523 24 32 23.5523 32 23V22H33C33.5523 22 34 22.4477 34 23V35C34 35.5523 33.5523 36 33 36H23C22.4477 36 22 35.5523 22 35V23C22 22.4477 22.4477 22 23 22H24V23C24 23.5523 24.4477 24 25 24C25.5523 24 26 23.5523 26 23V22H30ZM24 27C24 26.4477 24.4477 26 25 26H31C31.5523 26 32 26.4477 32 27C32 27.5523 31.5523 28 31 28H25C24.4477 28 24 27.5523 24 27ZM25 30C24.4477 30 24 30.4477 24 31C24 31.5523 24.4477 32 25 32H28C28.5523 32 29 31.5523 29 31C29 30.4477 28.5523 30 28 30H25Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_487_1010",
    x1: 0,
    y1: 28,
    x2: 56,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF914C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogo);
export default __webpack_public_path__ + "static/media/catalogo.602d07c3e496f50712bc8fd0a0dfd211.svg";
export { ForwardRef as ReactComponent };